<template>
  <HvhModal :value="true" title="Add Physician Group" max-width="100%" persistent @input="$emit('close')">
    <v-form @input="formValid = $event" ref="form">
      <component :is="column.component || 'v-text-field'" :label="column.label" :value="getValue(column.prop)" v-bind="column.props" v-on="column.on" @input="setValue(column.prop, $event)" v-for="column in columns" :key="column.prop" />
    </v-form>
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" @click="save">Save</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import axios from '../../axios'
import { errorDebug, tryParse } from '../../libraries/common';
import HvhModal from '../common/modal/HvhModal.vue'
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue';
import Th from '../../components/common/dataTable/Th.vue';
export default {
  components: { HvhModal, DataTableAsync, Th, },
  props: ['value', 'brandId', 'userId', 'group'],
  data() {
    return {
      searchItems: [],
      isLoading: false,
      zips: [],
      localValue: { additionalData: {} },
    };
  },
  computed: {
    columns() {
      var requiredRules = [v => !!v || v === false || v == 0 || 'Field is required'];
      return [
        { prop: 'organizationName', label: 'Organization Name', props: { rules: requiredRules }, },
        { prop: 'physicianGroupType', label: 'Physician Group Type' },
        { prop: 'physicianGroupMainSpecialty', label: 'Main Specialty' },
        { prop: 'additionalData.PHYSICIAN_GROUP_ADDRESS_1', label: 'Address 1', props: { rules: requiredRules } },
        { prop: 'additionalData.PHYSICIAN_GROUP_ADDRESS_2', label: 'Address 2' },
        {
          prop: 'physicianGroupZip',
          label: 'ZIP',
          component: 'v-autocomplete',
          props: {
            items: this.zips.map(f => f.zip),
            rules: requiredRules,
          },
          on: {
            input: (event) => {
              var zip = this.zips.find(f => f.zip === event);
              this.localValue = {
                ...this.localValue,
                physicianGroupCity: zip.city,
                physicianGroupState: zip.state,
                oasTerritoryId: zip.territory.id,
                oasTerritoryName: zip.territory.name,
                rodRegionId: zip.territory.region.id,
                rodRegionName: zip.territory.region.name,
              };
            },
          },
        },
        { prop: 'physicianGroupCity', label: 'City', props: { class: 'disabled' } },
        { prop: 'physicianGroupState', label: 'State', props: { class: 'disabled' } },
        { prop: 'oasTerritoryName', label: 'Territory Name', props: { class: 'disabled' } },
        { prop: 'additionalData.SEGMENT_TYPE', label: 'Segment Type' },
        {
          prop: 'additionalData.TIER_TARGET_FLAG_Y_N',
          label: 'Tier Target Flag',
          component: 'v-select',
          props: {
            items: ['Y', 'N'],
          },
        },
      ];
    }
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/CallPlanning/${this.brandId}/User/${this.userId}/AddFromTextOptions`)
        .then(({ data }) => {
          var zipToLocation = data.zip2Location.reduce((acc, f) => { acc[f.zip] = { state: f.state, city: f.city }; return acc; }, {});
          this.zips = data.zips2Territory.map(f => ({ ...f, ...zipToLocation[f.zip] }), {});
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false)
    },
    getValue(prop) {
      var fnc = new Function('value', `return value.${prop};`);
      return fnc(this.localValue);
    },
    setValue(prop, event) {
      var fnc = new Function('value, event', `value.${prop} = event; return value;`);
      this.localValue = { ...fnc(this.localValue, event) };
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      axios.post(`/api/CallPlanning/${this.brandId}/User/${this.userId}/PhysicianFromText`,
        { ...this.localValue, additionalData: JSON.stringify(this.localValue.additionalData) })
        .then(({ data }) => {
          this.$emit('addTarget', {
            ...data,
            physicianGroupList: {
              ...data.physicianGroupList,
              additionalData: tryParse(data.physicianGroupList.additionalData),
            }
          });
          this.$emit('close');
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  watch: {
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningAddText'] = this;

    this.getData();
  }
}
</script>